module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-13-min.56100343.jpg";